import type { AxiosPromise } from 'axios'

import request from '@/utils/request'
import type { GroupModel, GroupPayload } from '@/views/groups/types/GroupModel'

export function getGroups(): AxiosPromise<GroupModel[]> {
  return request<GroupModel[]>({
    url: '/api/groups',
    method: 'get'
  })
}

export function createGroup(data: GroupPayload): AxiosPromise<Pick<GroupModel, 'id'>> {
  return request<Pick<GroupModel, 'id'>>({
    url: '/api/groups',
    method: 'post',
    data
  })
}

export function updateGroup(groupId: GroupModel['id'], data: GroupPayload): AxiosPromise<void> {
  return request<void>({
    url: `/api/groups/${groupId}`,
    method: 'put',
    data
  })
}

export function deleteGroup(groupId: GroupModel['id']): AxiosPromise<void> {
  return request<void>({
    url: `/api/groups/${groupId}`,
    method: 'delete'
  })
}
